import { type AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type AnalyticsEvents, type TransformerEvents } from '../types/events'
import { addToCartTransformer } from './addToCartTransformer'
import { addToWishlistTransformer } from './addToWishlistTransformer'
import { beginCheckoutTransformer } from './beginCheckoutTransformer'
import { pageViewTransformer } from './pageViewTransformer'
import { purchaseTransformer } from './purchaseTransformer'
import { removeFromCartTransformer } from './removeFromCartTransformer'
import { signUpTransformer } from './signUpTransformer'
import { viewItemListTransformer } from './viewItemListTransformer'
import { viewItemTransformer } from './viewItemTransformer'
import { viewMyAccountTransformer } from './viewMyAccountTrasformer'

export type DniAnalysisTransformer = (platform: AnalyticsPlatforms, event: AnalyticsEvents) => AnalyticsEvents | TransformerEvents | null

export const transformers: Partial<Record<AnalyticsEvents['eventName'], DniAnalysisTransformer>> = {
  add_to_cart: addToCartTransformer,
  remove_from_cart: removeFromCartTransformer,
  view_item: viewItemTransformer,
  view_item_list: viewItemListTransformer,
  begin_checkout: beginCheckoutTransformer,
  add_to_wishlist: addToWishlistTransformer,
  purchase: purchaseTransformer,
  view_my_account: viewMyAccountTransformer,
  page_view: pageViewTransformer,
  sign_up: signUpTransformer,
}
